import React, { useState, useEffect } from "react";
import { Nav } from "../../components/nav";
import { useAuth } from "../../navigation/AuthProvider";
import axios from "axios";
import { BACKEND_URL } from "../../constants";
import "../css/CompanySettings.css";

export const CompanySettings = () => {

  const {
    company,
    setCompany,
    user,
  } = useAuth();

  // AUTO PROJECT ASSIGNMENT
  const [enabled, setEnabled] =
    useState(false);

  const [visibility, setVisibility] =
    useState("all");

  // ADVANCED SCHEDULING
  const [
    advancedSchedulingEnabled,
    setAdvancedSchedulingEnabled,
  ] = useState(true);

  // VISA PERSONALSIDAN I APPEN
  const [
    showPersonnelInApp,
    setShowPersonnelInApp,
  ] = useState(true);

  const [saving, setSaving] =
    useState(false);

  const [
    showSavedMessage,
    setShowSavedMessage,
  ] = useState(false);

  useEffect(() => {

    if (company?.autoProjectAssignment) {

      setEnabled(
        company.autoProjectAssignment.enabled
      );

      setVisibility(
        company.autoProjectAssignment.visibility
        || "all"
      );
    }

    setAdvancedSchedulingEnabled(
      company?.advancedSchedulingEnabled
      ?? true
    );

    setShowPersonnelInApp(
      company?.showPersonnelInApp
      ?? true
    );

  }, [company]);

  const handleSave = async () => {

    try {

      setSaving(true);

      const { data } = await axios.put(
        `${BACKEND_URL}/update-company-settings`,
        {

          userId: user._id,
          companyId: company._id,

          // AUTO PROJECT ASSIGNMENT
          enabled,
          visibility,

          // ADVANCED SCHEDULING
          advancedSchedulingEnabled,

          // VISA PERSONALSIDAN I APPEN
          showPersonnelInApp,
        }
      );

      if (data.status === "success") {

        setCompany(data.company);

        setShowSavedMessage(true);

        setTimeout(() => {

          setShowSavedMessage(false);

        }, 3000);

      } else {

        console.error(data.errorText);

      }

    } catch (err) {

      console.error(err);

    } finally {

      setSaving(false);

    }
  };

  return (
    <div className="companySettings-root">

      <Nav />

      <div className="companySettings-container">

        <div className="companySettings-header">

          <div>

            <h1>
              Företagsinställningar
            </h1>

            <p className="companySettings-subhead">
              Hantera dina företagsinställningar
              och schemainställningar
            </p>

          </div>

        </div>

        {/* AUTO PROJECT ASSIGNMENT */}
        <div className="companySettings-card">

          <div className="companySettings-row">

            <div className="companySettings-info">

              <div className="companySettings-title">
                Automatisk projekttilldelning
              </div>

              <div className="companySettings-desc">
                Lägg till användare i projekt
                när de får ett pass.
              </div>

            </div>

            <label className="companySettings-switch">

              <input
                type="checkbox"
                checked={enabled}
                onChange={() =>
                  setEnabled(!enabled)
                }
              />

              <span className="companySettings-slider"></span>

            </label>

          </div>

          {enabled && (

            <div className="companySettings-row companySettings-subRow">

              <div className="companySettings-info">

                <div className="companySettings-title">
                  Synlighet
                </div>

                <div className="companySettings-desc">
                  Bestämmer vilka pass
                  användaren ser.
                </div>

              </div>

              <div className="companySettings-options">

                <button
                  className={`companySettings-optionBtn ${
                    visibility === "all"
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    setVisibility("all")
                  }
                >
                  Alla pass
                </button>

                <button
                  className={`companySettings-optionBtn ${
                    visibility === "own"
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    setVisibility("own")
                  }
                >
                  Endast egna pass
                </button>

              </div>
            </div>
          )}
        </div>

        {/* ADVANCED SCHEDULING */}
        <div className="companySettings-card">

          <div className="companySettings-row">

            <div className="companySettings-info">

              <div className="companySettings-title">
                Avancerad schemaläggning
              </div>

              <div className="companySettings-desc">
                Aktiverar flytta pass,
                kopiera pass och avancerade
                drag-and-drop funktioner
                i schemat.
              </div>

            </div>

            <label className="companySettings-switch">

              <input
                type="checkbox"
                checked={
                  advancedSchedulingEnabled
                }
                onChange={() =>
                  setAdvancedSchedulingEnabled(
                    !advancedSchedulingEnabled
                  )
                }
              />

              <span className="companySettings-slider"></span>

            </label>

          </div>

        </div>

        {/* PERSONALSIDAN I APPEN */}
        <div className="companySettings-card">

          <div className="companySettings-row">

            <div className="companySettings-info">

              <div className="companySettings-title">
                Visa personalsidan i appen
              </div>

              <div className="companySettings-desc">
                Visar menyvalet ”Personal” i appen,
                med namn, telefonnummer och e-post
                till alla anställda. Stäng av om ni
                inte vill att anställda ska se
                vilka som arbetar i företaget.
              </div>

            </div>

            <label className="companySettings-switch">

              <input
                type="checkbox"
                checked={showPersonnelInApp}
                onChange={() =>
                  setShowPersonnelInApp(
                    !showPersonnelInApp
                  )
                }
              />

              <span className="companySettings-slider"></span>

            </label>

          </div>

        </div>

        {/* SAVE */}
        <div className="companySettings-actionBar">

          <button
            className="companySettings-saveBtn"
            onClick={handleSave}
            disabled={saving}
          >

            {saving ? (
              <>
                <span className="spinner"></span>
                Sparar…
              </>
            ) : (
              "Spara ändringar"
            )}

          </button>

          {showSavedMessage && (
            <div className="companySettings-toast">
              ✓ Inställningarna sparades
            </div>
          )}

        </div>
      </div>
    </div>
  );
};